import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "./components/HeroSection";
import HotRanking from "./components/HotRanking";
import CategorySection from "./components/CategorySection";
import FeaturedSection from "./components/FeaturedSection";
import PrincipleSection from "./components/PrincipleSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import { useSeo, SITE_NAME, SITE_ORIGIN } from "@/hooks/useSeo";
import { articles } from "@/mocks/articles";
import { faqs } from "@/mocks/site";
import { sortByHeat } from "@/utils/articles";

export default function Home() {
  const top = sortByHeat(articles).slice(0, 8);

  useSeo({
    title: "看料88｜今日猛料与热门大瓜合集，全网热点实时更新",
    description:
      "看料88是专注文娱热点的聚合站，提供今日猛料、最新爆料合集和热门大瓜的实时更新，按时间线整理起因与进展，全网瓜汇总一页看全。",
    keywords: "看料88,今日猛料,最新爆料合集,热门大瓜,实时更新料,全网瓜汇总",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: SITE_NAME,
        url: SITE_ORIGIN,
        inLanguage: "zh-CN",
        description:
          "专注文娱热点的话题聚合站，提供今日猛料、最新爆料合集与热门大瓜的实时更新与时间线整理。",
        potentialAction: {
          "@type": "SearchAction",
          target: {
            "@type": "EntryPoint",
            urlTemplate: `${SITE_ORIGIN}/materials?q={search_term_string}`,
          },
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: SITE_NAME,
        url: SITE_ORIGIN,
        email: "contact@kanliao88.example",
        description: "看料88，专注文娱热点的话题聚合与时间线整理。",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "今日热度榜",
        itemListElement: top.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.title,
          url: `${SITE_ORIGIN}/material/${item.slug}`,
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ],
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <HotRanking />
        <CategorySection />
        <FeaturedSection />
        <PrincipleSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}